/**
 * Interceptors support following methods:
 * request, response, requestError, responseError
 */

(function () {
	angular
		.module('trackeye')
		.factory('JsonInterceptor', JsonInterceptor);

	JsonInterceptor.$inject = [];

	function JsonInterceptor() {
		var exports = {};

		exports.request = function (config) {
			if (!config.headers.hasOwnProperty('Content-Type')) {
				config.headers['Content-Type'] = "application/json";
			}
			config.headers['Accept'] = "application/json";

			return config;
		};

		return exports;
	}
})();